import clsx from 'clsx';
import styles from './legend.module.scss';
import { LegendItem, LegendOrientation } from './legend.types';

interface LegendProps {
  items: LegendItem[];
  orientation?: LegendOrientation;
  className?: string;
}

export default function Legend({ items, orientation = 'horizontal', className }: LegendProps) {
  return (
    <div className={clsx(styles.legend, styles[`legend-${orientation}`], className)}>
      {items.map((item, index) => (
        // Index key: labels come from API topic names and can repeat.
        <span className={styles.item} key={`${item.label}-${index}`}>
          <i className={styles.swatch} style={{ backgroundColor: item.color }} />
          {item.label}
          {item.value && <b className={styles.value}>{item.value}</b>}
        </span>
      ))}
    </div>
  );
}
